var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-details" },
    [
      _vm.showProfileTop
        ? _c(
            "div",
            {
              staticClass: "user-info-profile",
              on: { click: _vm.viewContactProfile },
            },
            [
              _c(
                "div",
                { staticClass: "profile-header" },
                [
                  _c("ContactAvatar", {
                    key: _vm.contact._id,
                    attrs: {
                      contact: _vm.contact,
                      badge: true,
                      "badge-type": _vm.IsVisitorOnline()
                        ? "visitor-online"
                        : "visitor-offline",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "contact-profile-info" }, [
                    _c("div", { staticClass: "contact-profile-fullname" }, [
                      _vm.contact.vipCustomer
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                    delay: [600, 0],
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                                },
                              ],
                              staticClass: "material-icons vip",
                              attrs: { content: "★ VIP Customer" },
                            },
                            [
                              _vm._v(
                                "\n                        star\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getVal("fullname")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "platform-info" }, [
                      _c("div", { staticClass: "platform-name" }, [
                        _c(
                          "div",
                          { staticClass: "platform-icon-wrapper" },
                          [
                            _vm.contact.platform === "whatsapp"
                              ? _c("WhatsappIcon", {
                                  staticClass: "option-icon",
                                  attrs: { color: "#25D366" },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contact.platform === "telegram"
                              ? _c("TelegramIcon", {
                                  staticClass: "option-icon",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contact.platform === "messenger"
                              ? _c("MessengerIcon", {
                                  staticClass: "option-icon",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contact.platform === "web"
                              ? _c("webIcon", {
                                  staticClass: "option-icon",
                                  attrs: { color: "black;" },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contact.platform === "email"
                              ? _c("mailIcon", { staticClass: "option-icon" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contact.platform === "meta-leads"
                              ? _c("MetaIcon", { staticClass: "option-icon" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contact.platform === "instagram"
                              ? _c("InstagramIcon", {
                                  staticClass: "option-icon",
                                  attrs: { "special-background-mode": "" },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getPlatformName()) +
                                "\n                        "
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.contact.platform === "whatsapp"
                        ? _c(
                            "div",
                            {
                              staticClass: "whatsapp-number",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.showWhatsappChatStarterModal = true
                                },
                              },
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: "javascript:void(0)" } },
                                [_vm._v(_vm._s(_vm.contact.whatsappNumber))]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: { title: "WhatsApp Chat Başlat", showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.contact.whatsappNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-email": _vm.contact.email,
                  "default-name": _vm.contact.name || _vm.contact.fullname,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "user-info-details-wrapper" }, [
        _c("div", { staticClass: "user-info-details-title" }, [
          _vm._v(_vm._s(_vm.$t("visitor.visitorDetail"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-info-details-content" },
          [
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: "VIP Customer",
                value: _vm.getVal("vipCustomer"),
                showEdit: true,
                showDelete: false,
                showCopy: true,
                field: "vipCustomer",
                "input-type": "switch",
              },
              on: {
                edit: function ($event) {
                  return _vm.updateContactDetailKey("vipCustomer", $event)
                },
                add: function ($event) {
                  return _vm.addContactDetailKey("vipCustomer", $event)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("message.fullName"),
                value: _vm.getVal("fullname"),
                showEdit: true,
                showDelete: false,
                showCopy: true,
              },
              on: {
                edit: function ($event) {
                  return _vm.updateContactDetailKey("fullname", $event)
                },
                add: function ($event) {
                  return _vm.addContactDetailKey("fullname", $event)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("message.email"),
                value: _vm.getVal("email"),
                showEdit: true,
                showDelete: false,
                showCopy: true,
                field: "email",
              },
              on: {
                edit: function ($event) {
                  return _vm.updateContactDetailKey("email", $event)
                },
                add: function ($event) {
                  return _vm.addContactDetailKey("email", $event)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("alternate_email"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "contact-properties-box" },
              [
                _c(
                  "div",
                  {
                    staticClass: "btnShowContactProperties",
                    on: {
                      click: function ($event) {
                        _vm.showContactProperties = !_vm.showContactProperties
                      },
                    },
                  },
                  [
                    _vm.showContactProperties
                      ? _c("span", [
                          _vm._v(
                            "\n                        Diğer Bilgileri Gizle\n                        "
                          ),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("expand_less"),
                          ]),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n                        Diğer Bilgileri Göster\n                        "
                          ),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("expand_more"),
                          ]),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _vm.showContactProperties
                  ? _c("ContactProperties", {
                      attrs: {
                        contact: _vm.contact,
                        "show-widget-title": false,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.getCustomLoginInfos(), function (inputValue) {
              return _c("ContactDetailItem", {
                key: inputValue.id,
                attrs: {
                  contact: _vm.contact,
                  label: inputValue.name,
                  value: inputValue.value,
                  showDelete: false,
                  showEdit: false,
                  showAdd: false,
                },
                on: {
                  updated: function ($event) {
                    return _vm.updateCustomLoginFormInfo(inputValue, $event)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("alternate_email"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "value",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s(inputValue.value) +
                              "\n                "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("whatsappChannel.channelName"),
                value: _vm.getPlatform(),
                showEdit: false,
                showDelete: false,
                showCopy: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("PlatformIcon", {
                        attrs: { platform: _vm.contact.platform, size: 20 },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("message.preferredLanguage"),
                value: _vm.getPreferredLang(),
                showEdit: true,
                showDelete: false,
                showCopy: true,
                field: "preferredLang",
              },
              on: { edit: _vm.updatePreferredLang },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("FlagSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("visitor.tags"),
                value: _vm.contact.tags,
                showEdit: true,
                showDelete: false,
                showCopy: true,
                field: "tags",
              },
              on: { edit: _vm.updateTags },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("TagSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _vm.contact.lastConversation.subject
              ? _c("ContactDetailItem", {
                  attrs: {
                    contact: _vm.contact,
                    label: _vm.$t("chatWindow.departmentToWhichItIsAffiliated"),
                    value: _vm.subjectName(
                      _vm.contact.lastConversation.subject
                    ),
                    showEdit: false,
                    showDelete: false,
                    showCopy: true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function () {
                          return [
                            _c("Department", {
                              staticStyle: { width: "20px", height: "20px" },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    978541739
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: "Ülke, Dil",
                value: _vm.getCountryAndLanguage(),
                showEdit: false,
                showDelete: false,
                showCopy: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("FlagSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("message.os_browser"),
                value: _vm.getOs(),
                showEdit: false,
                showDelete: false,
                showCopy: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("BrowserSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("message.ipAddress"),
                value: _vm.getVal("ipAddress"),
                showEdit: false,
                showDelete: false,
                showCopy: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("BrowserSearchSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: _vm.$t("userInfoWidget.speechID"),
                value: _vm.getVal("lastConversation._id"),
                showEdit: false,
                showDelete: false,
                showCopy: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("UserCardSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("ContactDetailItem", {
              attrs: {
                contact: _vm.contact,
                label: "Ziyaretçi Kimliği",
                value: _vm.getVal("_id"),
                showEdit: false,
                showDelete: false,
                showCopy: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("FingerSvg")]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showTagDialog
        ? _c("TagDialog", {
            attrs: { value: _vm.getContactTagIds() },
            on: {
              input: _vm.contactTagUpdated,
              close: function ($event) {
                _vm.showTagDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }